// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"a31d44af","456":"e5da2e8c","656":"ad49f084","756":"a3a0cbd1","968":"f18a08d0"}[chunkId] + ".chunk.js";
};